import { render, staticRenderFns } from "./pdfEditor.vue?vue&type=template&id=6c7ff19f&scoped=true&"
import script from "./pdfEditor.vue?vue&type=script&lang=js&"
export * from "./pdfEditor.vue?vue&type=script&lang=js&"
import style0 from "./pdfEditor.vue?vue&type=style&index=0&id=6c7ff19f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ff19f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\工作项目\\编辑pdf签字签名\\pdf_sign_editor\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7ff19f')) {
      api.createRecord('6c7ff19f', component.options)
    } else {
      api.reload('6c7ff19f', component.options)
    }
    module.hot.accept("./pdfEditor.vue?vue&type=template&id=6c7ff19f&scoped=true&", function () {
      api.rerender('6c7ff19f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdfEditor.vue"
export default component.exports